export enum Role {
	VIEW = 'view',
	CREATE = 'create',
	CREATE_SIGN = 'create_sign',
	SIGN = 'sign',
	MANAGE = 'manage',
}

export enum Capability {
	CREATE_PAYMENT = 'createPayment',
	SIGN_PAYMENT = 'signPayment',
	DELETE_PAYMENT = 'deletePayment',
	MANAGE_TEMPLATE = 'manageTemplate',
}
